import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';

export type MarkupConfigurationRow = TrpcOutputs['getMarkupConfigurations'][1][number];

export const useMarkupConfigurations = (queryParams: TrpcInputs['getMarkupConfigurations']) => {
  const query = trpc.getMarkupConfigurations.useQuery(queryParams, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    data: query.data?.[1],
    count: query.data?.[0],
    isLoading: Boolean(query.isLoading),
    error: query.error?.message,
    refetch: query.refetch,
  };
};
